import React from 'react';

const Profile = ({ user }) => {
  const totalPoints = user?.points_total ?? 12500;
  const redeemed = user?.points_redeemed ?? 12000;

  return (
    <div className="max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold">{user?.name}</h1>
          <div className="text-sm text-gray-500">Designation</div>
        </div>
        <div className="text-right">
          <div className="text-xs text-gray-500">Total Points Earned</div>
          <div className="text-xl font-semibold">{totalPoints}</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <h3 className="text-sm font-medium text-gray-900">Sales Performance</h3>
        <div className="mt-4 h-40 flex items-center justify-center text-gray-400">[Sales graph placeholder — Daily/Weekly/Monthly]</div>
      </div>

      <div className="bg-white rounded-lg shadow p-4">
        <h3 className="text-sm font-medium text-gray-900">Badge Collection</h3>
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-3">
          {[
            { key: 'consistency', label: 'Consistency King', icon: 'shield' },
            { key: 'star', label: 'Star Seller', icon: 'star' },
            { key: 'top', label: 'Top Performer', icon: 'trophy' }
          ].map(b => (
            <div key={b.key} className="bg-indigo-50 rounded p-3 text-center flex flex-col items-center justify-center">
              <div className="h-10 w-10 rounded-full bg-white flex items-center justify-center mb-2">
                {b.icon === 'shield' && (
                  <svg className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 2l7 4v6c0 5-3.582 9-7 10-3.418-1-7-5-7-10V6l7-4z" />
                  </svg>
                )}
                {b.icon === 'star' && (
                  <svg className="h-5 w-5 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.966a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.38 2.455a1 1 0 00-.364 1.118l1.286 3.966c.3.921-.755 1.688-1.54 1.118L10 15.347l-3.985 2.643c-.784.57-1.84-.197-1.54-1.118l1.286-3.966a1 1 0 00-.364-1.118L2.023 9.393c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69L9.05 2.927z" />
                  </svg>
                )}
                {b.icon === 'trophy' && (
                  <svg className="h-5 w-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V6a4 4 0 014-4v0a4 4 0 014 4v1m-9 0h10a2 2 0 002-2V5a2 2 0 00-2-2h-1M5 7h14v2a5 5 0 01-5 5H10a5 5 0 01-5-5V7zM9 20h6M12 16v4" />
                  </svg>
                )}
              </div>
              <div className="text-xs font-medium text-indigo-900">{b.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Profile;
